/*
 * TUMLE: the sticky add-to-cart bar (sections/sticky-atc-bar.liquid) follows
 * the package selected in the bundle picker (Kaching Bundles app) in the main
 * product column:
 * - price: the package total, "750 DKK" with "890 DKK" struck through for 2x
 *   (also when the picker shows the price per set on top);
 * - image: with several items, their selected colours stacked side by side
 *   (e.g. Nordic + Rainbow) instead of the single product image.
 *
 * Kaching renders late and re-renders on every click, and the theme writes the
 * variant price and image into the bar on variant changes, so this watches both
 * and puts the package back whenever they differ. Only the main product's
 * picker counts; a featured-product section further down can carry its own.
 * Styles in assets/tumle_sticky-bundle.css.
 */
(function () {
  const bar = document.querySelector('.tum-sticky-atc');
  const info = document.querySelector('[id^="ProductInfo-"][id$="__main"]');
  if (!bar || !info) return;

  const amount = bar.querySelector('.tum-sticky-atc__amount');
  const compare = bar.querySelector('.tum-sticky-atc__compare');
  const thumb = bar.querySelector('.tum-sticky-atc__thumb');
  if (!amount) return;

  let stack = null;
  if (thumb) {
    stack = document.createElement('div');
    stack.className = 'tumle_sticky-stack';
    stack.setAttribute('aria-hidden', 'true');
    thumb.after(stack);
  }

  let queued = false;

  function selectedPackage() {
    const selected = info.querySelector('.kaching-bundles__bar--selected');
    if (!selected) return null;
    // With "prices per item" on, the option shows the price per set on top
    // and the total in a second row; the bar shows the total
    const row = selected.querySelector('.kaching-bundles__bar-pricing-row--secondary') || selected;
    const price = row.querySelector('.kaching-bundles__bar-price')?.innerText.trim();
    if (!price) return null;
    const full = row.querySelector('.kaching-bundles__bar-full-price')?.innerText.trim() || '';
    // One selected swatch per item row; its image is the swatch's background
    const images = [...selected.querySelectorAll('.kaching-bundles__swatch-buttons')]
      .map((row) => row.querySelector('.kaching-bundles__swatch-buttons__button--selected .kaching-bundles__swatch'))
      .map((swatch) => (swatch ? getComputedStyle(swatch).backgroundImage : 'none'))
      .filter((image) => image && image !== 'none');
    return { price, full, images };
  }

  function applyImages(images) {
    if (!stack) return;
    const key = images.length > 1 ? images.join('|') : '';
    if (stack.dataset.key === key) return;
    stack.dataset.key = key;
    stack.replaceChildren(
      ...(key ? images : []).map((image) => {
        const item = document.createElement('span');
        item.className = 'tumle_sticky-stack__item';
        item.style.backgroundImage = image;
        return item;
      })
    );
    bar.classList.toggle('tumle_sticky-stack--on', Boolean(key));
  }

  function apply() {
    queued = false;
    const pkg = selectedPackage();
    if (!pkg) return;
    if (amount.textContent.trim() !== pkg.price) amount.textContent = pkg.price;
    if (compare) {
      if (pkg.full && pkg.full !== pkg.price) {
        if (compare.textContent.trim() !== pkg.full) compare.textContent = pkg.full;
        compare.classList.remove('is-hidden');
      } else if (!compare.classList.contains('is-hidden')) {
        compare.classList.add('is-hidden');
      }
    }
    applyImages(pkg.images);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(apply);
  }

  // Package and colour changes (and Kaching's first render) in the main product column
  new MutationObserver(queue).observe(info, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'style'],
  });
  // The theme writing the variant price back into the bar
  new MutationObserver(queue).observe(amount.parentElement, { subtree: true, childList: true, characterData: true });

  queue();
})();
